import React from 'react';

import { ViewType, useViewType } from '@eika/hooks';

import { ComparisonTableDesktop } from './ComparisonTableDesktop';
import { ComparisonTableMobile } from './ComparisonTableMobile';
import { ComparisonTableProps } from './ComparisonTableTypes';

export const DATA_TRACK_PREFIX_COMPARISON_TABLE = 'comparison-table';

const ComparisonTable = ({ rows, tableHeadColumns, firstColumnHeader, compact = false }: ComparisonTableProps) => {
    const singleDekning = tableHeadColumns.length === 1;
    const view = useViewType();
    const footnotes: string[] = rows
        .reduce((accumulator: string[], row) => {
            if (row.titleFootnote) {
                accumulator.push(row.titleFootnote);
            }
            if (row.subTexts) {
                row.subTexts.forEach((sub) => {
                    if (sub.footnote) {
                        accumulator.push(sub.footnote);
                    }
                });
            }
            return accumulator;
        }, [])
        .filter(Boolean);
    const numberOfStarsBasedOnFootnotesIndex = (footnote: string) => '*'.repeat(footnotes.indexOf(footnote) + 1);
    return (
        <>
            {view === ViewType.desktop || singleDekning ? (
                <ComparisonTableDesktop
                    rows={rows}
                    tableHeadColumns={tableHeadColumns}
                    firstColumnHeader={firstColumnHeader}
                    compact={compact}
                    numberOfStarsBasedOnFootnotesIndex={numberOfStarsBasedOnFootnotesIndex}
                />
            ) : (
                <ComparisonTableMobile
                    rows={rows}
                    tableHeadColumns={tableHeadColumns}
                    numberOfStarsBasedOnFootnotesIndex={numberOfStarsBasedOnFootnotesIndex}
                />
            )}
            <div className="sgw-comparison-table__footnotes">
                {footnotes.map((footnote, index) => {
                    return <span key={footnote}>{`${'*'.repeat(index + 1)} ${footnote}`}</span>;
                })}
            </div>
        </>
    );
};

export default ComparisonTable;
